export default [
  {
    name: 'defaultToolsAccountManage',
    path: 'accountManage',
    component: () => import(
      /* webpackChunkName: 'defaultToolsAccountManage'*/
      '../views/toolsForDoctor/accountManage/index.vue'),
  },
  {
    name: 'defaultToolsAdminManage',
    path: 'adminManage',
    component: () => import(
      /* webpackChunkName: 'defaultToolsAdminManage'*/
      '../views/toolsForDoctor/adminManage/index.vue'),
  },
];
